import { useReducedMotion } from 'motion/react';

/** Single entry point for components that animate via JS (`motion/react`). */
export function usePrefersReducedMotion(): boolean {
  return useReducedMotion() ?? false;
}
